import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Link } from "react-router-dom";
import { Loader, Text, Button, SearchBar, Theme, ContentSmall } from '@simplybenefits/sb-ui-library';

import AccountCard from '../../components/Cards/AccountCard.js';
import { getAccountsSpecific } from '../../actions/accounts.js';
import permissionLevel from '../../services/permissions.js';

class PendingAccountList extends PureComponent {
    state = {
        query: ''
    };

    static getDerivedStateFromProps(props) {
        if (!permissionLevel('Accounts', props.accessType).includes('read')) {
            window.location.href = '/403';
        }

        return null;
    }

    componentDidMount() {
        this.props.dispatch(getAccountsSpecific(this.state.query, 0, 0));
    }

    // submit a new search, we must reset the cursor
    _search = () => {
        this.props.dispatch(getAccountsSpecific(this.state.query, 0, 0));
    };

    _handleInputChange = (type, event) => {
        this.setState({
            [type]: event.target.value
        });
    };

    _loadMore = () => {
        this.props.dispatch(getAccountsSpecific(this.state.query, false, 0));
    };

    render() {
        if (!this.props.accounts) {
            return <Loader isContainer/>;
        }

        let noResults = true;

        this.props.accounts.map((account) => {
            if (account.status === 0) {
                noResults = false;
            }

            return noResults;
        });

        return (
            <ContentSmall style={{ width: "60%" }}>
                <SearchBar
                    onChange={(value) => this._handleInputChange('query', value)}
                    search={this._search}
                    placeholder="Search..."
                    iconColor={Theme.colors.skyBlue}
                    customStyle={{
                        margin: '20px auto',
                        width: '100%',
                        backgroundColor: Theme.colors.surface
                    }}
                />

                {
                    this.props.accounts.map((account, i) => {
                        if (account.status === 0) {
                            return (
                                <Link key={account.accountID} to={`/accounts/${ account.accountID }`} style={{ textDecoration: 'none' }}>
                                    <AccountCard testid={i === 0 ? 'account-card' : undefined} account={account}/>
                                </Link>
                            );
                        }

                        return true;
                    })
                }

                {
                    noResults &&
                    <Text
                        align="center"
                        mediumLarge
                        display="block"
                    >
                        No results to display
                    </Text>
                }

                {
                    this.props.cursor >= 0 &&
                    <Button
                        onClick={this._loadMore}
                        color="primary"
                        marginTop={2.5}
                        fullWidth
                    >
                        Load More
                    </Button>
                }

                <span id="advisor-pending-accounts" />
            </ContentSmall>

        );
    }
}

PendingAccountList.propTypes = {
    accounts: PropTypes.array,
    cursor: PropTypes.number,
    advisor: PropTypes.object,
    accessType: PropTypes.string
};

/**
 *
 * @param {*} state
 */
const mapStateToProps = (state) => ({
    loader: state.loader,
    accounts: state.advisors.currentAdvisor.accounts,
    cursor: state.advisors.currentAdvisor.cursor,
    advisor: state.advisors.currentAdvisor,
    accessType: state.master.access
});

export default connect(mapStateToProps)(PendingAccountList);